import ConfigsProvider from "./context/ConfigsProvider";
import Routing from "./Routing";

function App() {
  return (
    <ConfigsProvider>
      <Routing />
    </ConfigsProvider>
  );
}

export default App;
